export default __webpack_public_path__ + "static/media/patient.d6de3e98.jpg";